import { render, staticRenderFns } from "./yueChengBen.vue?vue&type=template&id=47d146c7&scoped=true&"
import script from "./yueChengBen.vue?vue&type=script&lang=js&"
export * from "./yueChengBen.vue?vue&type=script&lang=js&"
import style0 from "./yueChengBen.vue?vue&type=style&index=0&id=47d146c7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d146c7",
  null
  
)

export default component.exports